import {FooterType} from "../app/FooterType";
import {PledgerAction} from "@pledger/frontend-commons";
import {PledgerPageComponentState} from "../../services/ui/PledgerPageComponentState";
import {Reducer} from "redux";
import {ChangePhoneNumberActions} from "./ChangePhoneNumberActions";
import {changePhoneNumberWServiceActions} from "../../services/ws/changePhoneNumber/changePhoneNumberWServiceActions";

const footerType = (state = FooterType.NONE, action : PledgerAction) => {
    switch (action.type) {
        default:
            return FooterType.NONE;
    }
};

const pageRequestError = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case changePhoneNumberWServiceActions.CHANGE_PHONE_NUMBER_GET_REQUEST_CODE_FAILED_ACTION.type:
            return true;

        default:
            return state;
    }
};

const pageLoaded = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case changePhoneNumberWServiceActions.CHANGE_PHONE_NUMBER_GET_REQUEST_CODE_SUCCEEDED_ACTION.type:
            return true;

        default:
            return state;
    }
};

const partialEmail = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case changePhoneNumberWServiceActions.CHANGE_PHONE_NUMBER_GET_REQUEST_CODE_SUCCEEDED_ACTION.type:
            return action.payload.data.partialEmail ?? '';

        default:
            return state;
    }
};

const validationCode = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case ChangePhoneNumberActions.CHANGE_PHONE_NUMBER_VALIDATION_CODE_CHANGE_ACTION.type:
            return action.payload.validationCode;
        default:
            return state;
    }
};

const validationCodeError = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case changePhoneNumberWServiceActions.CHANGE_PHONE_NUMBER_GET_REQUEST_CODE_FAILED_ACTION.type:
            return true;
        default:
            return state;
    }
};

const changeToken = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case changePhoneNumberWServiceActions.CHANGE_PHONE_NUMBER_PUT_VALIDATION_CODE_SUCCEEDED_ACTION.type:
            return action.payload.data.changeToken;
        default:
            return state;
    }
};

const oldPhoneNumber = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case changePhoneNumberWServiceActions.CHANGE_PHONE_NUMBER_PUT_VALIDATION_CODE_SUCCEEDED_ACTION.type:
            return action.payload.data.phoneNumber;
        default:
            return state;
    }
};

const validationCodeSent = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case changePhoneNumberWServiceActions.CHANGE_PHONE_NUMBER_PUT_VALIDATION_CODE_SUCCEEDED_ACTION.type:
            return true;

        default:
            return state;
    }
};

const newPhoneNumber = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case ChangePhoneNumberActions.CHANGE_PHONE_NUMBER_NEW_PHONE_NUMBER_CHANGE_ACTION.type:
            return action.payload.newPhoneNumber;
        default:
            return state;
    }
};

const newPhoneNumberInvalid = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case ChangePhoneNumberActions.CHANGE_PHONE_NUMBER_NEW_PHONE_INVALID_ACTION.type:
            return true;

        case ChangePhoneNumberActions.CHANGE_PHONE_NUMBER_NEW_PHONE_NUMBER_CHANGE_ACTION.type:
            return false;

        default:
            return state;
    }
};

const newPhoneNumberSent = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case changePhoneNumberWServiceActions.CHANGE_PHONE_NUMBER_POST_NEW_PHONE_NUMBER_SUCCEEDED_ACTION.type:
            return true;

        default:
            return state;
    }
};

const newPartialPhoneNumber = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case changePhoneNumberWServiceActions.CHANGE_PHONE_NUMBER_POST_NEW_PHONE_NUMBER_SUCCEEDED_ACTION.type:
            return action.payload.data.newPartialPhoneNumber;

        default:
            return state;
    }
};

const validationId = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case changePhoneNumberWServiceActions.CHANGE_PHONE_NUMBER_POST_NEW_PHONE_NUMBER_SUCCEEDED_ACTION.type:
            return action.payload.data.validationId;
        default:
            return state;
    }
};

const newPhoneNumberValidationCode = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case ChangePhoneNumberActions.CHANGE_PHONE_NUMBER_NEW_PHONE_NUMBER_VALIDATION_CODE_CHANGE_ACTION.type:
            return action.payload.newPhoneNumberValidationCode;
        default:
            return state;
    }
};

const newPhoneNumberValidationCodeError = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case changePhoneNumberWServiceActions.CHANGE_PHONE_NUMBER_PUT_NEW_PHONE_NUMBER_VALIDATION_FAILED_ACTION.type:
            return true;
        default:
            return state;
    }
};

export interface ChangePhoneNumberPageComponentState extends PledgerPageComponentState {
    pageRequestError: boolean;
    pageLoaded: boolean;
    partialEmail: string;
    validationCode: string;
    validationCodeError: boolean;
    changeToken: string;
    oldPhoneNumber: string;
    validationCodeSent: boolean;
    newPhoneNumber: string;
    newPhoneNumberInvalid: boolean;
    newPhoneNumberSent: boolean;
    newPartialPhoneNumber:string;
    validationId: string;
    newPhoneNumberValidationCode: string;
    newPhoneNumberValidationCodeError: boolean;
}

export const changePhoneNumber : Reducer = (state={},action)=>{
    return{
        footerType: footerType(state.footerType, action),
        pageRequestError: pageRequestError(state.pageRequestError, action),
        pageLoaded: pageLoaded(state.pageLoaded, action),
        partialEmail: partialEmail(state.partialEmail, action),
        validationCode: validationCode(state.validationCode, action),
        validationCodeError: validationCodeError(state.validationCodeError, action),
        changeToken: changeToken(state.changeToken, action),
        oldPhoneNumber: oldPhoneNumber(state.oldPhoneNumber, action),
        validationCodeSent: validationCodeSent(state.validationCodeSent, action),
        newPhoneNumber: newPhoneNumber(state.newPhoneNumber, action),
        newPhoneNumberInvalid: newPhoneNumberInvalid(state.newPhoneNumberInvalid, action),
        newPhoneNumberSent: newPhoneNumberSent(state.newPhoneNumberSent, action),
        validationId: validationId(state.validationId, action),
        newPartialPhoneNumber:newPartialPhoneNumber(state.newPartialPhoneNumber,action),
        newPhoneNumberValidationCode: newPhoneNumberValidationCode(state.newPhoneNumberValidationCode, action),
        newPhoneNumberValidationCodeError: newPhoneNumberValidationCodeError(state.newMailValidationCodeError, action),
    }
}
